'use client';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Upload } from 'lucide-react';
import * as React from 'react';
import ReactDropzone, { ErrorCode } from 'react-dropzone';
import { cn, formatBytes } from '../../lib/utils.js';
var DEFAULT_ACCEPT = {
    // Image
    'image/*': [],
    // PDF
    'application/pdf': [],
    // Excel
    'application/vnd.ms-excel': [],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
    // Word
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [],
    'application/msword': [],
    // PowerPoint
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': [],
    // CSV
    'text/csv': [],
};
var DEFAULT_CUSTOMIZATION = {
    icon: <Upload className={cn('text-accent-foreground', 'size-5')} aria-hidden="true"/>,
    title: 'Drag & Drop files here or click to select files',
    description: function (maxSize, maxCount, multiple) {
        if (maxCount === undefined || maxCount === Infinity) {
            return "You can upload multiple files with a maximum size of ".concat(formatBytes(maxSize), " each.");
        }
        if (maxCount === 1 || !multiple) {
            return "You can upload one file with a maximum size of ".concat(formatBytes(maxSize), ".");
        }
        return "You can upload ".concat(maxCount, " files with a maximum size of ").concat(formatBytes(maxSize), " each.");
    },
};
export var Dropzone = function (_a) {
    var _b = _a.customization, customization = _b === void 0 ? {} : _b, _c = _a.multiple, multiple = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.accept, accept = _e === void 0 ? DEFAULT_ACCEPT : _e, _f = _a.maxSize, maxSize = _f === void 0 ? 1024 * 1024 * 10 : _f, maxFiles = _a.maxFiles, onFilesChange = _a.onFilesChange, className = _a.className;
    var _g = React.useState([]), errors = _g[0], setErrors = _g[1];
    var icon = customization.icon || DEFAULT_CUSTOMIZATION.icon;
    var title = customization.title || DEFAULT_CUSTOMIZATION.title;
    var description = customization.description
        ? typeof customization.description === 'function'
            ? customization.description(maxSize, maxFiles, multiple)
            : customization.description
        : DEFAULT_CUSTOMIZATION.description(maxSize, maxFiles, multiple);
    var onDrop = React.useCallback(function (acceptedFiles, rejectedFiles) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setErrors([]);
            if (!multiple && acceptedFiles.length > 1) {
                setErrors([
                    {
                        code: 'max_file_count_exceeded',
                        message: 'Cannot upload more than 1 file at a time',
                        key: Math.random().toString(),
                    },
                ]);
                return [2 /*return*/];
            }
            onFilesChange(acceptedFiles);
            if (rejectedFiles.length > 0) {
                setErrors(function (errors) { return __spreadArray(__spreadArray([], errors, true), rejectedFiles.map(function (_a) {
                    var file = _a.file, fileErrors = _a.errors;
                    return ({
                        code: 'file_rejected',
                        message: fileErrors.some(function (_a) {
                            var code = _a.code;
                            return code === ErrorCode.FileTooSmall;
                        })
                            ? "File ".concat(file.name, " is corrupted")
                            : "File ".concat(file.name, " was rejected"),
                        key: Math.random().toString(),
                    });
                }), true); });
            }
            return [2 /*return*/];
        });
    }); }, [multiple, onFilesChange]);
    var onError = React.useCallback(function (error) {
        setErrors(function (errors) { return __spreadArray(__spreadArray([], errors, true), [
            { code: 'file_rejected', message: error.message, key: Math.random().toString() },
        ], false); });
    }, []);
    var hasErrors = errors.length > 0;
    return (<>
      <ReactDropzone onDrop={onDrop} onError={onError} accept={accept} maxSize={maxSize} minSize={1} maxFiles={maxFiles} multiple={multiple} disabled={disabled}>
        {function (_a) {
            var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, isDragActive = _a.isDragActive;
            return (<div {...getRootProps()} className={cn('border-muted-foreground/25 hover:bg-primary/10 group relative grid w-full cursor-pointer place-items-center rounded border-2 border-dashed px-5 py-2 text-center transition', 'ring-offset-background focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none', 'bg-background/90 text-accent', isDragActive && 'border-muted-foreground/50 border-solid', disabled && 'pointer-events-none opacity-60', className)}>
            <input {...getInputProps()}/>
            {isDragActive ? (<div className="flex flex-col items-center justify-center gap-2 sm:px-5">
                {icon}
                <p className={cn('text-muted-foreground font-medium', 'text-sm')}>
                  Drop the files here
                </p>
              </div>) : (<div className="flex flex-col items-center justify-center gap-2 sm:px-5">
                {icon}
                <div className="flex flex-col gap-px">
                  <p className="text-accent-foreground font-medium">{title}</p>
                  <p className="text-accent-foreground/70 text-sm">{description}</p>
                </div>
              </div>)}
            {hasErrors && (<div className="mt-2 space-y-1 text-sm text-red-700 dark:text-red-400">
                {errors.map(function (error) { return (<div key={error.key}>- {error.message}</div>); })}
              </div>)}
          </div>);
        }}
      </ReactDropzone>
    </>);
};
